class EpisodelistController {
  constructor($state, $scope, $q, $timeout, DTOptionsBuilder, DTColumnBuilder, DTDefaultOptions, USER, Constants, CONST,
    materialButtons, datePicker, $rootScope, $location, FunctionService) {

    this.datatableApi;
    this.user = USER;
    this.name = 'Episode List';
    this.episodeValue = '';
    this.specialtyString = '';
    this.separationString = '';
    this.TEC = "TODO";
    this.TEA = "TODO";

    this.locale = 'en-au';

    this.url = WEBSERVICEURL + '/dataagility/api/service.episodeaudit?removeCoding=1&';
    this.initUrl = this.url + 'startDate=' + moment().locale(this.locale).subtract(1, 'months').startOf('month').format('L') + '&endDate=' + moment().locale(this.locale).subtract(1, 'days').format('L');

    FunctionService.getFunctions($rootScope.globals.currentUser.roleId).then(
      function (response) {
        $scope.vm.episodeValue = response.functionSettings.EpisodeValue.valueString;
        $scope.vm.specialtyString = response.functionSettings.SpecialtyString.valueString;
        $scope.vm.separationString = response.functionSettings.SeparationString.valueString;
      }
    );

    materialButtons.render();

    materialButtons.processing();

    $scope.initCallback = function(nRow, aData, iDisplayIndex, iDisplayIndexFull) {

      // Datatables has finished init
      // Initialise searching
      if ($scope.vm.datatableApi)
        return;

      $scope.vm.datatableApi = this.api();

      // Update column headers even when no data returned
      setDtHeaders($scope.vm.datatableApi);

      // setup search filters
      search();

      // set the table to a fixed height, so it never collapsed up and down
      $('#auditTable').closest(".dataTables_scrollBody").height(300);

    }

    this.dtOptions = DTOptionsBuilder.newOptions()
      .withOption('ajax', {
        headers: { Authorization: 'Bearer ' + $rootScope.globals.currentUser.token },
        url: $scope.vm.initUrl,
        type: 'GET',
        error: (xhr, error, thrown) => {
          if (thrown == 'Unauthorized') {
            //window.location.replace(window.location.origin + '/login');
            console.log('Unauthorized request with token: ', $rootScope.globals.currentUser.token);
        }
        }
      })
      .withDisplayLength(CONST.TABLEROWS)
      .withDataProp('data')
      .withOption('processing', true)
      .withOption('sAjaxDataProp', '')
      .withOption('bLengthChange', false)
      .withPaginationType('simple_numbers')
      .withOption('rowCallback', function (row, data, index) {
        // Update column headers if data returned
        setDtHeaders($('#auditTable').DataTable());
      })
      .withOption('drawCallback', $scope.drawCallback)
      .withOption('initComplete', $scope.initCallback)
      .withOption('scrollY', '300px')
      .withOption('scrollX', 'auto')
      .withOption('aaSorting', [
        [2, 'asc']
      ])
      .withOption('dom', '<"wrapper"rt<"table-footer"iBp>>')
      .withButtons([
        {
          extend: 'print',
          text: ''
        },
        {
          extend: 'csvHtml5',
          text: '',
          filename: $scope.vm.name + "-" + moment().format("YYYYMMDD-HHmm")
        }, {
          extend: 'excelHtml5',
          text: '',
          filename: $scope.vm.name + "-" + moment().format("YYYYMMDD-HHmm")
        }, {
          text: '',
          action: function (e, dt, node, config) {
              dt.ajax.reload();
          }
        }
      ])

      .withColumnFilter({
        //sPlaceHolder: "head:after",
        aoColumns: [
          { type: 'number' },
          { type: "date-range" },
          { type: "date-range" },
          { type: "select" },
          { type: "select" },
          { type: "select" },
          { type: "number" }, {
            type: "text",
            bRegex: true,
            bSmart: true
          },
          { type: "number" }
        ]
      });

    function yesNo(data) {
      return (data === true) ? "Y" : "N";
    }

    this.dtColumns = [
      DTColumnBuilder.newColumn('urn').withTitle('UR Number').withClass('mdl-data-table__cell--non-numeric'),
      DTColumnBuilder.newColumn('admissionDate').withTitle('Admission Date').withClass('mdl-data-table__cell--non-numeric'),
      DTColumnBuilder.newColumn('dischargeDate').withTitle('Loading...').withClass('mdl-data-table__cell--non-numeric'),
      DTColumnBuilder.newColumn('speciality').withTitle('Loading...').withOption('defaultContent', '').withClass('mdl-data-table__cell--non-numeric'),
      DTColumnBuilder.newColumn('auditCriteria').withTitle('Audit Criteria').withOption('defaultContent', '').withClass('mdl-data-table__cell--non-numeric'),
      DTColumnBuilder.newColumn('status').withTitle('Audit Status').withOption('defaultContent', '').withClass('mdl-data-table__cell--non-numeric'),
      DTColumnBuilder.newColumn('drg').withTitle('Original DRG').withOption('defaultContent', '0').withClass('mdl-data-table__cell--non-numeric'),
      DTColumnBuilder.newColumn('finalDRG').withTitle('Final DRG').withOption('defaultContent', '0').withClass('mdl-data-table__cell--non-numeric'),
      DTColumnBuilder.newColumn('wies').withTitle('Loading...').withOption('defaultContent', '0.0000').withClass('mdl-data-table__cell--non-numeric')
      .renderWith(function(data, type, full) {
        return parseFloat(data).toFixed(4);
      }),
      DTColumnBuilder.newColumn('finalWIES').withTitle('Loading...').withOption('defaultContent', '0.0000').withClass('mdl-data-table__cell--non-numeric')
      .renderWith(function(data, type, full) {
        if ( typeof(data) !== 'undefined')
          return parseFloat(data).toFixed(4);
      }),
      DTColumnBuilder.newColumn('totalWIESChange').withTitle('Loading...').withOption('defaultContent', '0.0000').withClass('mdl-data-table__cell--non-numeric')
      .renderWith(function(data, type, full) {
        return parseFloat(data).toFixed(4);
      }),
      DTColumnBuilder.newColumn('auditFinalisedDateTime').withTitle('Date Audit Finalised').withOption('defaultContent', '').withClass('mdl-data-table__cell--non-numeric')
    ];

    // Search filters
    this.specialty = {
      selectedSpecialty: []
    };
    this.specialtyOptions = {};

    Constants.getDivisionAndSpecialtyData().then(
      function successCallback(response) {
        $scope.vm.specialtyOptions = response.specialties;
        filterSpecialty($scope.vm.specialtyOptions);
        // Can load divisions if needed??
      }
    );

    this.startDatePicker = {
      input: {
        date: moment().locale(this.locale).subtract(1, 'months').startOf('month'),
        dateFormatted: moment().locale(this.locale).subtract(1, 'months').startOf('month').format('L')
      }
    };
    this.endDatePicker = {
      input: {
        date: moment().locale(this.locale).subtract(1, 'days'),
        dateFormatted: moment().locale(this.locale).subtract(1, 'days').format('L')
      }
    };

    // callbacks for lx-selects and lx-date-picker
    this.specialtyCallback = specialtyCallback;
    datePicker.autoClose($scope);

    function setDtHeaders(table) {
      $(table.column(2).header()).html($scope.vm.separationString + ' Date');
      $(table.column(3).header()).html($scope.vm.specialtyString);
      $(table.column(8).header()).html('Original ' + $scope.vm.episodeValue);
      $(table.column(9).header()).html('Final ' + $scope.vm.episodeValue);
      $(table.column(10).header()).html($scope.vm.episodeValue + ' Change');
    }

    function specialtyCallback(_newValue, _oldValue) {
      $scope.vm.changeData();
    }

    function filterSpecialty(swap) {
      $scope.vm.specialty.selectedSpecialty = [];
      if (swap === 'add') {
        $scope.vm.specialty.selectedSpecialty = $scope.vm.specialtyOptions;
      }
    }

    function setDefaultDate() {

      $scope.vm.startDatePicker.input.date = moment().locale($scope.vm.locale).subtract(1, 'months').startOf('month');
      $scope.vm.startDatePicker.input.dateFormatted = moment().locale($scope.vm.locale).subtract(1, 'months').startOf('month').format('L');

      $scope.vm.endDatePicker.input.date = moment().locale($scope.vm.locale).subtract(1, 'days');
      $scope.vm.endDatePicker.input.dateFormatted = moment().locale($scope.vm.locale).subtract(1, 'days').format('L');

    }

    function checkParam(param) {

      if (param.length !== 0) {

        return encodeURIComponent(param.join());

      } else {

        return "";

      }

    }

    this.changeData = changeData;

    function changeData() {

      var newUrl = $scope.vm.url + 'startDate=' + $scope.vm.startDatePicker.input.dateFormatted + '&endDate=' + $scope.vm.endDatePicker.input.dateFormatted
          + '&specialty=' +checkParam($scope.vm.specialty.selectedSpecialty)
          // + '&auditCriteria=' + checkParam($scope.vm.auditCriteria.selectedCriteria);
      $scope.vm.datatableApi.ajax.url(newUrl).load().draw();

    }


    function search() {

      // delete any global searches previously applied
      if ($.fn.dataTable.ext.search.length === 1)
        $.fn.dataTable.ext.search.shift();

      var auditTable = $scope.vm.datatableApi;
      var clearAuditTable = auditTable.search('').draw();

      filterSpecialty('minus');

      // re-draw tabele on datepicker close
      $scope.$on('lx-date-picker__close-start', function(e, id) {

        $scope.vm.changeData();

      });

    }

    // bind the datatable instance to an object to monitor loading
    this.dtInstanceCallback = dtInstanceCallback;

    function dtInstanceCallback(dtInstance) {

      $scope.dtInstance = dtInstance._renderer;

    }

    // bind filter swap
    this.filterSwap = filterSwap;

    function filterSwap(thisFilter, thisModifier) {


      switch (thisFilter) {

        case 'specialty':

          if (thisModifier === 'add') {

            filterSpecialty('add');

          } else {

            filterSpecialty('minus');

          }

          break;

        default:
          break;
      }

    }


  }
}

export default EpisodelistController;



// WEBPACK FOOTER //
// ./client/app/common/reports/episodelist/episodelist.controller.js